import React from 'react'
import Topbar from '../Mainhomefour/Topbar'
import Header4 from '../../Globle/Header4'
import Smallnav from '../Mainhomefour/Smallnav'
import Banner from '../Mainhomefour/Banner'
import Service from '../Mainhomefour/Service'
import Furnitur from '../Mainhomefour/Furnitur'
import Tranding from '../Mainhomefour/Tranding'
import Sales from '../Mainhomefour/Sales'
import Featur from '../Mainhomefour/Featur'
import Partner from '../Mainhomefour/Partner'
import OverProdect from '../Mainhomefour/OverProdect'
import Testmonial from '../Mainhomefour/Testmonial'
import Blog from '../Mainhomefour/Blog'
import News from '../Mainhomefour/News'
import Footer from '../../Globle/Footer4'

const Main = () => {
    return (
        <>
            <Topbar />
            <Header4 />
            <Smallnav />
            <Banner />
            <Service />
            <Furnitur />
            <Tranding />
            <Sales />
            <Featur />
            <Partner />
            <OverProdect />
            <Testmonial />
            <Blog />
            <News />
            <Footer />

        </>
    )
}

export default Main
